import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  toStringicfo093rs8qc as toString,
  toUByte2hylyk0iwswr7 as toUByte,
  toStringo7o79ljd2a04 as toString_0,
  toUShort2g34vrqtz7wn0 as toUShort,
  toString10m9tj9xt75j5 as toString_1,
  toUInt1crqr0nr3w2ry as toUInt,
  toString1ced4mxyj2b43 as toString_2,
  toULong1ml5v40a0vtdq as toULong,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  padStart36w1507hs626a as padStart,
  removePrefix279df90bhrqqg as removePrefix,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Align_End_getInstancer37lklmdzqms as Align_End_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_shown_$ref_kipsub2u3yvjqlogkp3 as TextView$_get_shown_$ref_kipsub,
  TextView$_set_shown_$ref_l7jsq921p8dnwznnah1 as TextView$_set_shown_$ref_l7jsq9,
} from './CsvRenderer.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  cellView255m1dxiud5di as cellView,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerHex(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Byte'), HexByteRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Short'), HexShortRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Int'), HexIntRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Long'), HexLongRenderer_instance);
}
function HexByteRenderer$form$lambda$lambda(it) {
  // Inline function 'kotlin.toUByte' call
  var tmp$ret$0 = _UByte___init__impl__g9hnc4(it);
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = toString(tmp$ret$0, 16).toUpperCase();
  return '0x' + padStart(tmp$ret$1, 2, _Char___init__impl__6a9atx(48));
}
var HexByteRendererClass;
function HexByteRenderer() {
  if (HexByteRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Hex';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_3xh1i8_k$(context, module_0) {
        return 0.5;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_3xh1i8_k$(context, module_0);
      }
      form_cox8p2_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var errorMessage = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_0 = themed(element, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          element_0.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = HexByteRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, (original, newText) => {
            var tmp;
            try {
              errorMessage.set_value_v1vabv_k$(null);
              var cleaned = removePrefix(removePrefix(newText, '0x'), '0X');
              // Inline function 'kotlin.UByte.toByte' call
              var this_0 = toUByte(cleaned, 16);
              tmp = _UByte___get_data__impl__jof9qr(this_0);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                errorMessage.set_value_v1vabv_k$('Invalid hex');
                tmp_0 = original;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          }));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(errorMessage) == null));
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
            var tmp0_elvis_lhs = $this$invoke.invoke_r7m7el_k$(errorMessage);
            return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_cox8p2_k$(context, value, module_0);
      }
      view_lbvvcv_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'kotlin.toUByte' call
            var this_0 = $this$invoke.invoke_r7m7el_k$(value);
            var tmp$ret$3 = _UByte___init__impl__g9hnc4(this_0);
            // Inline function 'kotlin.text.uppercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$4 = toString(tmp$ret$3, 16).toUpperCase();
            return '0x' + padStart(tmp$ret$4, 2, _Char___init__impl__6a9atx(48));
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_lbvvcv_k$(context, value, module_0);
      }
      cellForm_c0hojo_k$(context, value, module_0) {
        return this.form_cox8p2_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_c0hojo_k$(context, value, module_0);
      }
      columnWidth_qu0dw_k$(context, module_0) {
        return 6.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_qu0dw_k$(context, module_0);
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'HexByteRenderer', VOID, VOID, [Renderer()]);
    HexByteRendererClass = $;
  }
  return HexByteRendererClass;
}
var HexByteRenderer_instance;
function HexByteRenderer_getInstance() {
  return HexByteRenderer_instance;
}
function HexShortRenderer$form$lambda$lambda(it) {
  // Inline function 'kotlin.toUShort' call
  var tmp$ret$0 = _UShort___init__impl__jigrne(it);
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = toString_0(tmp$ret$0, 16).toUpperCase();
  return '0x' + padStart(tmp$ret$1, 4, _Char___init__impl__6a9atx(48));
}
var HexShortRendererClass;
function HexShortRenderer() {
  if (HexShortRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Hex';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_60ybzu_k$(context, module_0) {
        return 0.5;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_60ybzu_k$(context, module_0);
      }
      form_zic8ee_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var errorMessage = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_0 = themed(element, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          element_0.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = HexShortRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, (original, newText) => {
            var tmp;
            try {
              errorMessage.set_value_v1vabv_k$(null);
              var cleaned = removePrefix(removePrefix(newText, '0x'), '0X');
              // Inline function 'kotlin.UShort.toShort' call
              var this_0 = toUShort(cleaned, 16);
              tmp = _UShort___get_data__impl__g0245(this_0);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                errorMessage.set_value_v1vabv_k$('Invalid hex');
                tmp_0 = original;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          }));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(errorMessage) == null));
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
            var tmp0_elvis_lhs = $this$invoke.invoke_r7m7el_k$(errorMessage);
            return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_zic8ee_k$(context, value, module_0);
      }
      view_r2zf1x_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'kotlin.toUShort' call
            var this_0 = $this$invoke.invoke_r7m7el_k$(value);
            var tmp$ret$3 = _UShort___init__impl__jigrne(this_0);
            // Inline function 'kotlin.text.uppercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$4 = toString_0(tmp$ret$3, 16).toUpperCase();
            return '0x' + padStart(tmp$ret$4, 4, _Char___init__impl__6a9atx(48));
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_r2zf1x_k$(context, value, module_0);
      }
      cellForm_mkzubo_k$(context, value, module_0) {
        return this.form_zic8ee_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_mkzubo_k$(context, value, module_0);
      }
      columnWidth_lnrkre_k$(context, module_0) {
        return 8.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_lnrkre_k$(context, module_0);
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'HexShortRenderer', VOID, VOID, [Renderer()]);
    HexShortRendererClass = $;
  }
  return HexShortRendererClass;
}
var HexShortRenderer_instance;
function HexShortRenderer_getInstance() {
  return HexShortRenderer_instance;
}
function HexIntRenderer$form$lambda$lambda(it) {
  // Inline function 'kotlin.toUInt' call
  var tmp$ret$0 = _UInt___init__impl__l7qpdl(it);
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = toString_1(tmp$ret$0, 16).toUpperCase();
  return '0x' + padStart(tmp$ret$1, 8, _Char___init__impl__6a9atx(48));
}
var HexIntRendererClass;
function HexIntRenderer() {
  if (HexIntRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Hex';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_ff740d_k$(context, module_0) {
        return 0.5;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_ff740d_k$(context, module_0);
      }
      form_56sy3q_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var errorMessage = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_0 = themed(element, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          element_0.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = HexIntRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, (original, newText) => {
            var tmp;
            try {
              errorMessage.set_value_v1vabv_k$(null);
              var cleaned = removePrefix(removePrefix(newText, '0x'), '0X');
              // Inline function 'kotlin.UInt.toInt' call
              var this_0 = toUInt(cleaned, 16);
              tmp = _UInt___get_data__impl__f0vqqw(this_0);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                errorMessage.set_value_v1vabv_k$('Invalid hex');
                tmp_0 = original;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          }));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(errorMessage) == null));
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
            var tmp0_elvis_lhs = $this$invoke.invoke_r7m7el_k$(errorMessage);
            return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_56sy3q_k$(context, value, module_0);
      }
      view_7yvvkr_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'kotlin.toUInt' call
            var this_0 = $this$invoke.invoke_r7m7el_k$(value);
            var tmp$ret$3 = _UInt___init__impl__l7qpdl(this_0);
            // Inline function 'kotlin.text.uppercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$4 = toString_1(tmp$ret$3, 16).toUpperCase();
            return '0x' + padStart(tmp$ret$4, 8, _Char___init__impl__6a9atx(48));
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_7yvvkr_k$(context, value, module_0);
      }
      cellForm_ytsllw_k$(context, value, module_0) {
        return this.form_56sy3q_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_ytsllw_k$(context, value, module_0);
      }
      columnWidth_30ef47_k$(context, module_0) {
        return 12.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_30ef47_k$(context, module_0);
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'HexIntRenderer', VOID, VOID, [Renderer()]);
    HexIntRendererClass = $;
  }
  return HexIntRendererClass;
}
var HexIntRenderer_instance;
function HexIntRenderer_getInstance() {
  return HexIntRenderer_instance;
}
function HexLongRenderer$form$lambda$lambda(it) {
  // Inline function 'kotlin.toULong' call
  var tmp$ret$0 = _ULong___init__impl__c78o9k(it);
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = toString_2(tmp$ret$0, 16).toUpperCase();
  return '0x' + padStart(tmp$ret$1, 16, _Char___init__impl__6a9atx(48));
}
var HexLongRendererClass;
function HexLongRenderer() {
  if (HexLongRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Hex';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_bhxcjv_k$(context, module_0) {
        return 0.5;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_bhxcjv_k$(context, module_0);
      }
      form_gksz3k_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var errorMessage = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_0 = themed(element, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          element_0.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = HexLongRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, (original, newText) => {
            var tmp;
            try {
              errorMessage.set_value_v1vabv_k$(null);
              var cleaned = removePrefix(removePrefix(newText, '0x'), '0X');
              // Inline function 'kotlin.ULong.toLong' call
              var this_0 = toULong(cleaned, 16);
              tmp = _ULong___get_data__impl__fggpzb(this_0);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                errorMessage.set_value_v1vabv_k$('Invalid hex');
                tmp_0 = original;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          }));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(errorMessage) == null));
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
            var tmp0_elvis_lhs = $this$invoke.invoke_r7m7el_k$(errorMessage);
            return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_gksz3k_k$(context, value, module_0);
      }
      view_civr33_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'kotlin.toULong' call
            var this_0 = $this$invoke.invoke_r7m7el_k$(value);
            var tmp$ret$3 = _ULong___init__impl__c78o9k(this_0);
            // Inline function 'kotlin.text.uppercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$4 = toString_2(tmp$ret$3, 16).toUpperCase();
            return '0x' + padStart(tmp$ret$4, 16, _Char___init__impl__6a9atx(48));
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_civr33_k$(context, value, module_0);
      }
      cellForm_fwdey6_k$(context, value, module_0) {
        return this.form_gksz3k_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_fwdey6_k$(context, value, module_0);
      }
      columnWidth_eokdo7_k$(context, module_0) {
        return 18.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_eokdo7_k$(context, module_0);
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'HexLongRenderer', VOID, VOID, [Renderer()]);
    HexLongRendererClass = $;
  }
  return HexLongRendererClass;
}
var HexLongRenderer_instance;
function HexLongRenderer_getInstance() {
  return HexLongRenderer_instance;
}
//region block: init
HexByteRenderer_instance = new (HexByteRenderer())();
HexShortRenderer_instance = new (HexShortRenderer())();
HexIntRenderer_instance = new (HexIntRenderer())();
HexLongRenderer_instance = new (HexLongRenderer())();
//endregion
//region block: exports
export {
  registerHex as registerHex4yx9p1vld97r,
};
//endregion

//# sourceMappingURL=HexRenderers.mjs.map
